import styled from 'styled-components'
import { customTheme } from '../../styles/theme'
interface IItemProps {
  $isMobile: boolean
}

// -------------MORE PAGE ------------------//
export const Container = styled.div`
  background-color: transparent;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  transition-duration: 0.7s;
  transition-property: transform;

  &.motionL{
    transform: translate(0vw);
  }

  &.motionR {
    transform: translate(100vw);
  }

`
export const ContainerDesktop = styled.div`
  background-color: transparent;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  transition-duration: 0.7s;
  transition-property: transform;

  &.motionL{
    transform: translate(0vw);
  }

  &.motionR {
    transform: translate(-100vw);
  }

`
export const ContainerMore = styled.div`
  background-color: #FFF;
  width: 48vw;
  max-width: 48vw;
  min-width: 48vw;
  height: 100%;
  z-index: 99999;
  position: fixed;
  bottom: 0;
  right: 0;

  display: flex;
  flex-direction: column;
`
export const ContainerMoreDesktop = styled.div`
  background-color: #FFF;
  width: 20vw;
  max-width: 20vw;
  min-width: 20vw;
  height: 100%;
  z-index: 99999;
  position: fixed;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TopContainer = styled.div`
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15%;

  .close {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 35%;
    aspect-ratio: 1/1;
    max-width: 120px;
    background-color: #606060;
  }
`
export const TopContainerDesktop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15%;
  margin-bottom: 10%;
`

export const BottomContainer = styled.div`
  margin-top: auto;
`
export const BottomDesktopContainer = styled.div`
  padding-bottom: 10vh;
   button, a {
    text-decoration: none !important;
    color: ${customTheme.colors.black};
    font-size: ${customTheme.fontSizes.sm};
    line-height: ${customTheme.fontSizes.md};
    width: 100%;
  }

  svg {
    margin-right: 5px;
  }
`

export const ItemMore = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  padding: 15px 10px;
  background-color: ${customTheme.colors.gray['400']};

  button, a {
    text-decoration: none !important;
    color: ${customTheme.colors.black};
    font-size: ${customTheme.fontSizes.sm};
    line-height: ${customTheme.fontSizes.md};
  }

  svg {
    margin-right: 5px;
  }

`
export const ItemMoreDesktop = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 15px 10px;
  background-color: ${customTheme.colors.gray['400']};
  justify-content: center;
  button, a {
    text-decoration: none !important;
    color: ${customTheme.colors.black};
    font-size: ${customTheme.fontSizes.sm};
    line-height: ${customTheme.fontSizes.md};
  }

  svg {
    margin-right: 5px;
  }
   
  &:hover {
    background-color: ${customTheme.colors.gray['800']};
  }
    
`

export const Name = styled.div`
  font-size: ${customTheme.fontSizes.sm};
  font-weight: 400;
`

export const LogoContainer = styled.div`
  max-width: 100%;

  img {
    object-position: unset;
    width: 100%;
  }

  margin: 10% 0;
`

export const Button = styled.button`
  border: none;
  background-color: transparent;
  font-weight: 400;
  padding: 0;
  text-align: start;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: row;
  
`
export const BackDrop = styled.div`
  background-color: transparent;
  width: 100vw;
  max-width: 100vw;
  min-width: 100vw;
  height: 100vh;
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
`

export const WrapperMobile = styled.div<IItemProps>`
  ${({ $isMobile }) => $isMobile && (
  `display: flex;
    height: 10vh;
    max-height: 10vh;
    min-height: 10vh;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    border-top: solid 1px ${customTheme.colors.gray['400']};

    align-items: center;
    justify-content: space-around;

    background-color: ${customTheme.colors.white};

    transition-duration: 2s;
    transition-property: transform;

    .active svg {
      transform: rotate(5deg);
      -webkit-transform: rotate(5deg);
    }`
  )}

   ${({ $isMobile }) => !$isMobile && (
  `
    display: flex;
    position: fixed;
    top: 20%;
    left: 0;
    z-index: 999;
    flex-direction: column;
    gap: 1vh;
    width: 7vw;
    padding: 1% 5px;
    border-radius: 5px;

    border: solid 1px #f1f1f1;

    align-items: center;
    justify-content: space-around;

    background-color: ${customTheme.colors.white};

    transition-duration: 2s;
    transition-property: transform;

    .active svg {
      transform: rotate(5deg);
      -webkit-transform: rotate(5deg);
    }`
  )}
  
`
export const ChatSpace = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 30px;
`

export const WelcomeName = styled.span`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 1rem;
`
